export const TAB_BUTTON_SX = {
  minWidth: 0,
  letterSpacing: 0,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  padding: '0 0 8px',
  border: 0,
  background: 'transparent',
  color: 'text.primary',
  font: 'inherit',
  fontSize: '32px',
  lineHeight: 1.15,
  cursor: 'pointer',
  '&:hover': {
    background: 'transparent',
  },
  '@media (max-width: 900px)': {
    flex: '0 0 auto',
  },
} as const;

export const TAB_BUTTON_ACTIVE_SX = {
  color: 'primary.main',
  '&::after': {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    height: '1px',
    background: 'currentColor',
    content: '""',
  },
} as const;

export const DASHBOARD_HEADER_SX = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2,
  marginBottom: 1.25,
  paddingLeft: 0.75,
  '@media (max-width: 900px)': {
    flexDirection: 'column',
    gap: 1.5,
    paddingLeft: 0,
  },
} as const;

export const TABS_SX = {
  display: 'flex',
  minWidth: 0,
  alignItems: 'flex-end',
  gap: 7,
  '@media (max-width: 900px)': {
    width: '100%',
    gap: 3,
    overflowX: 'auto',
  },
} as const;

export const ACTIONS_SX = {
  flex: '0 0 auto',
  paddingTop: 0.5,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1.25,
  '@media (max-width: 900px)': {
    alignSelf: 'flex-end',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
} as const;

const FLEX_COLUMN_SX = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
} as const;

export const GROUPED_TASKS_SX = { ...FLEX_COLUMN_SX, gap: 2.25 } as const;

export const TASK_LIST_SX = { ...FLEX_COLUMN_SX, gap: 1.25 } as const;

export const TASK_GROUP_SECTION_SX = { ...FLEX_COLUMN_SX, gap: 1 } as const;

export const TASK_GROUP_HEADER_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  paddingLeft: 0.25,
} as const;
